const buildBrandByIdUrl = (brandId: string): string => {
  const url = new URL(`${process.env.KOUTO_API_URL}/v1/brands/${brandId}`);
  return url.toString();
};

export default buildBrandByIdUrl;
